import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
export function WhoIsItFor() {
  const forYou = ['Amás a tu mascota pero estás al límite del colapso por el olor', 'Te mudaste hace poco y tu gato empezó a orinar fuera de la caja', 'Tenés más de un gato y hay tensión territorial', 'Estás cansado/a de tirar plata en productos que no sirven'];
  const notForYou = ['Buscás soluciones mágicas sin mover una caja de lugar', 'Creés que el castigo físico es la solución', 'Tu gato tiene obstrucciones urinarias (eso requiere un veterinario urgente)'];
  return <section className="w-full bg-white py-16 md:py-20 px-6" data-id="element-103">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-5xl mx-auto" data-id="element-104">
        <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-[#1C1C1C] mb-12 text-center" data-id="element-105">
          ¿Es para vos?
        </h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-106">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-[#E8F0E8] p-8 rounded-lg" data-id="element-107">
            <h3 className="font-['Playfair_Display'] text-2xl font-semibold text-[#2D8C5A] mb-6" data-id="element-108">
              Para vos si:
            </h3>
            <div className="space-y-4" data-id="element-109">
              {forYou.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-110">
                  <CheckCircleIcon className="w-6 h-6 text-[#2D8C5A] flex-shrink-0 mt-0.5" data-id="element-111" />
                  <p className="text-[#1C1C1C]" data-id="element-112">{item}</p>
                </div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-[#FAFAF7] p-8 rounded-lg border-2 border-[#8B4513]/20" data-id="element-113">
            <h3 className="font-['Playfair_Display'] text-2xl font-semibold text-[#8B4513] mb-6" data-id="element-114">
              No es para vos si:
            </h3>
            <div className="space-y-4" data-id="element-115">
              {notForYou.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-116">
                  <XCircleIcon className="w-6 h-6 text-[#8B4513] flex-shrink-0 mt-0.5" data-id="element-117" />
                  <p className="text-[#1C1C1C]" data-id="element-118">{item}</p>
                </div>)}
            </div>
          </motion.div>
        </div>
      </motion.div>
    </section>;
}